<template>
  <div>
    <el-dialog
      center
      destroy-on-close
      :close-on-click-modal="false"
      title="密码修改"
      :before-close="handleClose"
      :visible="visible"
      width="458px"
    >
      <el-form ref="paramsFormRef" :model="formParams" :rules="paramsRules" class="login-form">
        <el-form-item prop="password" label="原密码">
          <el-input
            v-model="formParams.password"
            prefix-icon="el-icon-lock"
            placeholder="请输入原密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="newPassword" label="新密码">
          <el-input
            v-model="formParams.newPassword"
            prefix-icon="el-icon-lock"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item prop="newPassword1" label="确认密码">
          <el-input
            v-model="formParams.newPassword1"
            prefix-icon="el-icon-lock"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" class="login-btn" @click="handleSure" :loading="btnLoading"
        >登录</el-button
      >
      <div style="text-align: center;">
        <el-button
          style="background-color: #fff;color: #90939B;margin: 0 auto;"
          type="primary"
          round
          @click="handleClose()"
          :loading="btnLoading"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import loginAPi from 'api/login.js';
import CryptoJS from 'crypto-js';

export default {
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请输入密码'));
      } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,16}$/.test(value)) {
        callback(new Error('6~16位字母、数字或特殊字符组合'));
      }
      // else if (
      //   !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@#$%&*]).{8,}$|^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).{8,}$|^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&*]).{8,}$|^(?=.*[a-z])(?=.*\\d)(?=.*[@#$%&*]).{8,}$|^(?=.*[A-Z])(?=.*\\d)(?=.*[@#$%&*]).{8,}$/.test(
      //     value
      //   )
      // ) {
      //   callback(new Error('8~16位包含大小写字母、数字或特殊字符组合'));
      // }
      else {
        callback();
      }
    };
    const validateNewPassword2 = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请输入密码'));
      } else if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,16}$/.test(value)) {
        callback(new Error('6~16位字母、数字或特殊字符组合'));
      } else if (value !== this.formParams.newPassword) {
        callback(new Error('请确认新密码两次相同'));
      } else {
        callback();
      }
    };
    return {
      paramsRules: {
        password: [{ trigger: 'blur', validator: validatePassword }],
        newPassword: [{ trigger: 'blur', validator: validatePassword }],
        newPassword1: [{ trigger: 'blur', validator: validateNewPassword2 }]
      },
      formParams: {
        userId: '',
        password: '',
        newPassword: '',
        newPassword1: ''
      },
      visible: false,
      btnLoading: false
    };
  },
  methods: {
    ...mapActions(['getUserInfo']),
    init() {
      this.getUser();
      this.visible = true;
    },
    getUser() {
      this.getUserInfo().then(res => {
        this.formParams.userId = res.data.data.userId;
      });
    },
    handleClose() {
      this.formParams = { userId: '', password: '', newPassword: '', newPassword1: '' };
      this.visible = false;
    },
    handleSure() {
      this.$refs.paramsFormRef.validate(valid => {
        if (!valid) {
          return;
        }
        this.btnLoading = true;
        let { newPassword1, ...obj } = this.formParams;
        obj.password = this.descWord(obj.password);
        obj.newPassword = this.descWord(obj.newPassword);
        loginAPi
          .updatePwd(obj)
          .then(res => {
            if (res.data.success) {
              this.btnLoading = false;
              this.handleClose();
              this.$message.success('修改成功');
              this.$emit('nextFun');
            }
          })
          .catch(err => {})
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    descWord(str) {
      var aseKey = 'hjiuhjsd'; //定制秘钥，长度必须为： 8/16/32位
      var message = str; //加密 DES/AES切换只需要修改 CryptoJS.AES <=> CryptoJS.DES
      var encrypt = CryptoJS.DES.encrypt(message, CryptoJS.enc.Utf8.parse(aseKey), {
        iv: CryptoJS.enc.Utf8.parse('hjiuhjsd'),
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      // console.log(encrypt.toString());
      return encrypt.toString();
      //解密
      /* var decrypt = CryptoJS.DES.decrypt(encrypt, CryptoJS.enc.Utf8.parse(aseKey), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);
      console.log(decrypt); */
    }
  }
};
</script>
<style lang="less" scoped>
.login-btn {
  width: 100%;
  background: linear-gradient(90deg, #4189fd 0%, #409dff 100%);
  box-shadow: 0px 3px 6px rgba(64, 157, 255, 0.3);
  opacity: 1;
  border-radius: 20px;
  margin-bottom: 16px;
  transition: all ease-in-out 0.2;
}
</style>
